/* eslint no-undef: off */
import { seoEnabled } from 'Seo/helpers';
import { noop } from 'underscore';

export default (getMetaInfoFn) => {
  const enabled = seoEnabled();
  if (!enabled) return;

  const path = window.location.pathname;

  Promise.all([getMetaInfoFn(), Booters.bootSeo()]).then(([metaInfo]) => {
    if (metaInfo && path === window.location.pathname) {
      reduxState.store.actionDispatchers.seo.setMetaInfo({
        ...metaInfo,
        path,
      });
    }
  }).catch(noop);
};
